import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Home from "./components/pages/Home";
import Privacy from "./components/Privacy";
import Cart from './components/pages/Cart';
import ThankYou from './components/pages/ThankYou';
import Cancelled from './components/pages/Cancelled';
import Subscription from './components/pages/Subscription';
import ThanksSub from './components/pages/ThanksSub.js';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path='privacy-policy' element={<Privacy />} />
          <Route path="register" element={<Cart />} />
          <Route path='thank-you' element={<ThankYou />} />
          {/* <Route path='cancelled-subscription' element={<Cancelled />} /> */}
          {/* <Route path='subscription' element={<Subscription />} />
          <Route path='subs-thanks' element={<ThanksSub />} /> */}
        </Routes>
        <Footer />
      </BrowserRouter>

    </div>
  );
}

export default App;
